import React from 'react';
import { Grid, Card, Stack, Typography, Skeleton, Button, Alert, Box } from '@mui/material';
import Iconify from '../../iconify/Iconify';

const KPI_CONFIG = [
  { key: 'bookings', label: 'Bookings', tone: 'rgba(25,118,210,0.10)', icon: 'solar:box-bold-duotone' },
  { key: 'scans', label: 'Scans', tone: 'rgba(2,136,209,0.10)', icon: 'solar:qr-code-bold' },
  { key: 'outForDelivery', label: 'Out for Delivery', tone: 'rgba(237,108,2,0.10)', icon: 'mdi:truck-fast' },
  { key: 'delivered', label: 'Delivered', tone: 'rgba(46,125,50,0.10)', icon: 'solar:check-read-bold' },
  { key: 'deliveryFailed', label: 'Delivery Failed', tone: 'rgba(211,47,47,0.10)', icon: 'solar:danger-triangle-bold' },
  { key: 'toPayPending', label: 'ToPay Pending', currency: true, tone: 'rgba(156,39,176,0.10)', icon: 'mdi:cash-clock' },
  { key: 'toPayCollected', label: 'ToPay Collected', currency: true, tone: 'rgba(2,119,189,0.10)', icon: 'mdi:cash-check' },
  { key: 'toPaySubmitted', label: 'ToPay Submitted', currency: true, tone: 'rgba(67,160,71,0.10)', icon: 'mdi:cash-sync' },
];

const formatValue = (value, currency) => {
  if (currency) return `₹${Number(value || 0).toLocaleString()}`;
  return Number(value || 0).toLocaleString();
};

export default function SummaryCards({ loading, error, data, onRetry }) {
  if (error) {
    return (
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        }
        sx={{ mb: 3 }}
      >
        Failed to load summary.
      </Alert>
    );
  }

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {KPI_CONFIG.map((item) => (
        <Grid key={item.key} item xs={12} sm={6} md={3}>
          <Card
            sx={{
              p: 2.1,
              borderRadius: 3,
              background: `linear-gradient(150deg, ${item.tone}, rgba(255,255,255,0.98))`,
              border: '1px solid',
              borderColor: 'divider',
              boxShadow: '0 8px 22px rgba(16, 24, 40, 0.05)',
              transition: 'transform 0.18s ease, box-shadow 0.18s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 14px 28px rgba(16, 24, 40, 0.08)',
              },
            }}
          >
            <Stack spacing={1}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: 0.4 }}>
                  {item.label}
                </Typography>
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    bgcolor: 'rgba(255,255,255,0.7)',
                    border: '1px solid rgba(0,0,0,0.06)',
                    display: 'grid',
                    placeItems: 'center',
                  }}
                >
                  <Iconify icon={item.icon} width={16} />
                </Box>
              </Stack>
              {loading ? (
                <Skeleton variant="text" width={120} height={40} />
              ) : (
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 800,
                    lineHeight: 1.2,
                    fontSize: { xs: '1.35rem', md: '1.55rem' },
                  }}
                >
                  {formatValue(data?.[item.key], item.currency)}
                </Typography>
              )}
            </Stack>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
